import { API_PREFIX } from '@/config/api'
import api from '@/helpers/api'
import type { PaginationDataType, PaginationType } from '@/types/PaginationType'
import type { ShuttleEpcModel, ShuttleEpcRangeResult } from '@/types/models/ShuttleEpcModel'
import { buildQueryUrl } from '@/utils/queryUtils'

const SHUTTLE_EPC_PREFIX = `${API_PREFIX}/shuttle-epcs`

const shuttleEpcApi = {
    getShuttleEpcs: (
        params?: Partial<PaginationType & any>
    ): Promise<PaginationDataType<ShuttleEpcModel[]>> =>
        api.get(`${SHUTTLE_EPC_PREFIX}${buildQueryUrl(params)}`).then(response => response.data),

    createShuttleEpc: (data: { epc: string }): Promise<{ data: ShuttleEpcModel }> =>
        api.post(SHUTTLE_EPC_PREFIX, data).then(response => response.data),

    createShuttleEpcRange: (data: {
        start: string
        end: string
    }): Promise<{ data: ShuttleEpcRangeResult }> =>
        api.post(`${SHUTTLE_EPC_PREFIX}/range`, data).then(response => response.data),

    deleteShuttleEpc: (id: number): Promise<void> =>
        api.delete(`${SHUTTLE_EPC_PREFIX}/${id}`).then(response => response.data)
}

export default shuttleEpcApi
